export default __webpack_public_path__ + "static/media/linkImage.0b5b428e.svg";